<template>
  <div class="row">
    <div class="col-md-6">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">
            Bookings by Hour of Day
            <CalculationTooltip text="Distribution of completed sessions by their start time hour." />
          </h3>
        </div>
        <div class="panel-body">
          <BarChart v-if="hourData" :data="hourData" :options="chartOptions" />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">
            Bookings by Day of Week
            <CalculationTooltip text="Distribution of completed sessions by the day of the week they occurred." />
          </h3>
        </div>
        <div class="panel-body">
          <BarChart v-if="dayData" :data="dayData" :options="chartOptions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bar as BarChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from './CalculationTooltip.vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
  name: 'BookingPatternsChart',
  components: { BarChart, CalculationTooltip },
  props: {
    bookingPatterns: { type: Object, required: true }
  },
  computed: {
    hourData() {
      if (!this.bookingPatterns || !this.bookingPatterns.by_hour) return null;
      var byHour = this.bookingPatterns.by_hour;
      return {
        labels: byHour.map(function(d) { return d.hour_label; }),
        datasets: [{
          label: 'Sessions',
          data: byHour.map(function(d) { return d.sessions; }),
          backgroundColor: '#5cb85c'
        }]
      };
    },
    dayData() {
      if (!this.bookingPatterns || !this.bookingPatterns.by_day_of_week) return null;
      var byDay = this.bookingPatterns.by_day_of_week;
      return {
        labels: byDay.map(function(d) { return d.day_label; }),
        datasets: [{
          label: 'Sessions',
          data: byDay.map(function(d) { return d.sessions; }),
          backgroundColor: '#f0ad4e'
        }]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false }
        },
        scales: {
          y: { beginAtZero: true }
        }
      };
    }
  }
};
</script>
